import { useForm } from '@mantine/form'
import { modals } from '@mantine/modals'
import showModalNotification from '@v2/commons/modals/ModalNotification/showModalNotification'
import { handleMutationError } from '@v2/commons/utils/errorHandling/handleMutationError'

import { LocationDto } from 'src/api/generated'

import { useDeleteLocationMutation } from '../api/location.api'

export const useDeleteLocation = (locationId: string) => {
  const [deleteLocation, { isLoading }] = useDeleteLocationMutation()

  const form = useForm<Pick<LocationDto, `id`>>({
    mode: 'uncontrolled',
    initialValues: {
      id: locationId,
    },
    validateInputOnBlur: true,
  })

  const onSubmit = () => {
    form.onSubmit(async (values) => {
      try {
        await deleteLocation(values.id).unwrap()
        modals.closeAll()
        showModalNotification({
          title: 'Success',
          subtitle: 'Location successfully deleted!',
        })
        return true
      } catch (err) {
        return handleMutationError(err, 'Location Delete')
      }
    })()
  }

  return {
    onSubmit,
    isLoading,
  }
}
